import { API_ADMIN_MEDICATIONS, API_ADMIN_PAP_FORMS } from './constants';

export const apiAdminMedications = () => API_ADMIN_MEDICATIONS;

export const apiAdminMedicationDetails = (medicationGuid = ':medicationGuid') =>
  `${API_ADMIN_MEDICATIONS}/${medicationGuid}`;

export const apiAdminPapForms = () => API_ADMIN_PAP_FORMS;

export const apiAdminPapFormsConfirm = (papFormGuid = ':papFormGuid') =>
  `${API_ADMIN_PAP_FORMS}/${papFormGuid}/confirm`;

export const apiAdminPapFormUpdate = (papFormGuid = ':papFormGuid') =>
  `${API_ADMIN_PAP_FORMS}/${papFormGuid}`;

export const apiAdminMedicationPapForms = (
  medicationGuid = ':medicationGuid',
) => `${API_ADMIN_MEDICATIONS}/${medicationGuid}/pap-forms`;

export const apiPapFormTemplateDownload = (papFormGuid = ':papFormGuid') =>
  `${API_ADMIN_PAP_FORMS}/${papFormGuid}/download`;
